"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var PhotoSwipe = require("photoswipe");
var PhotoSwipeUI_Default = require("photoswipe/dist/photoswipe-ui-default");
require("photoswipe/dist/photoswipe.css");
require("photoswipe/dist/default-skin/default-skin.css");
var BaseComponent_1 = require("../../../../../common/js/BaseComponent");
var ImagePhotoswipe = /** @class */ (function (_super) {
    __extends(ImagePhotoswipe, _super);
    function ImagePhotoswipe($view) {
        var _this = _super.call(this, $view) || this;
        _this.bind();
        return _this;
    }
    ImagePhotoswipe.prototype.bind = function () {
        this.gallery(document.documentElement, document.querySelector(".pswp"));
        // Pour le mode Produit si on a besoin de remplacer le visuel affiché en grand
        // Soit on rend générique, soit on fait un deuxième photoswipe juste pour les images produits
        // $('.img-gallery a').on('click', event => {
        //     event.preventDefault()
        //     const a : JQuery = $(event.target).parent('a')
        //     this.replaceMainPhoto( a )
        // })
    };
    ImagePhotoswipe.prototype.gallery = function (where, holder) {
        var _this = this;
        var galleryElements = where.querySelectorAll(".big-img");
        var _loop_1 = function (element) {
            var galleryID = element.dataset.gallery;
            var items = where.querySelectorAll("[data-gallery='".concat(galleryID, "']"));
            element.addEventListener("click", function (event) {
                event.preventDefault();
                //this.setOriginMainImageSrc()
                _this.openPhotoSwipe(holder, _this.galleryItemsElementsToArray(items), galleryID, Array.from(items).indexOf(event.currentTarget));
            });
        };
        for (var _i = 0, galleryElements_1 = galleryElements; _i < galleryElements_1.length; _i++) {
            var element = galleryElements_1[_i];
            _loop_1(element);
        }
    };
    ImagePhotoswipe.prototype.openPhotoSwipe = function (holder, items, galleryID, index) {
        if (index === void 0) { index = 0; }
        var options = {
            history: true,
            shareEl: false,
            galleryUID: galleryID,
            index: index
        };
        var gallery = new PhotoSwipe(holder, PhotoSwipeUI_Default, items, options);
        this.photoswipePreviews(gallery);
        gallery.init();
    };
    ImagePhotoswipe.prototype.galleryItemsElementsToArray = function (anchors) {
        var array = [];
        var img;
        for (var _i = 0, anchors_1 = anchors; _i < anchors_1.length; _i++) {
            var anchor = anchors_1[_i];
            // Récupération de la balise IMG c'est ce qui sert à générer la mini vignette
            // en bas du photoswipe lorsqu'il est chargé
            img = anchor.querySelector("img");
            var full = anchor.href;
            var preview = img.src;
            var title = img.alt;
            var _a = anchor.dataset.size.split("x"), width = _a[0], height = _a[1];
            array.push({
                src: full,
                msrc: preview,
                w: width,
                h: height,
                title: title
            });
        }
        return array;
    };
    ImagePhotoswipe.prototype.photoswipePreviews = function (gallery) {
        var _this = this;
        var added = false;
        gallery.listen("gettingData", function () {
            if (added)
                return;
            added = true;
            _this.addPreviews(gallery, "[data-previews]");
        });
        gallery.listen("close", function () {
            _this.removePreviews(gallery, "[data-previews]");
        });
        gallery.listen("afterChange", function () {
            _this.setActivePreview(gallery, "[data-previews]");
        });
    };
    ;
    ImagePhotoswipe.prototype.addPreviews = function (gallery, selector) {
        var scrollWrap = gallery.scrollWrap, items = gallery.items;
        var place = scrollWrap.querySelector(selector);
        var _loop_2 = function (item) {
            var preview = item.msrc;
            var element = document.createElement("img");
            element.setAttribute("src", preview);
            element.addEventListener("click", function () {
                gallery.goTo(items.indexOf(item));
            });
            place.appendChild(element);
        };
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            _loop_2(item);
        }
    };
    ImagePhotoswipe.prototype.removePreviews = function (gallery, selector) {
        var scrollWrap = gallery.scrollWrap;
        var place = scrollWrap.querySelector(selector);
        place.innerHTML = "";
    };
    ImagePhotoswipe.prototype.setActivePreview = function (gallery, selector) {
        var scrollWrap = gallery.scrollWrap, currItem = gallery.currItem;
        var preview = currItem.msrc;
        var place = scrollWrap.querySelector(selector);
        var previewElements = place.querySelectorAll("img");
        for (var _i = 0, previewElements_1 = previewElements; _i < previewElements_1.length; _i++) {
            var element = previewElements_1[_i];
            var src = element.getAttribute("src");
            var className = "is-active";
            // Warning: collision possible if image not unique
            if (src === preview) {
                element.classList.add(className);
                element.scrollIntoView({ behavior: "smooth" });
            }
            else
                element.classList.remove(className);
        }
    };
    return ImagePhotoswipe;
}(BaseComponent_1.default));
exports.default = ImagePhotoswipe;
